/**
 * Tab icons drawn from the same vocabulary as the gauges and the strata:
 * vertical ticks and measured marks. Stroke-only, `currentColor`, so the
 * active-tab brass carries through without a second definition.
 */

const base = {
  viewBox: "0 0 20 20",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.6,
  strokeLinecap: "round" as const,
  strokeLinejoin: "round" as const,
  className: "glyph",
  "aria-hidden": true,
};

/** Feed: a run of ticks — the archive as a sequence of records. */
export const FeedIcon = () => (
  <svg {...base}>
    <path d="M3 13v4M7 8v9M11 11v6M15 5v12" />
  </svg>
);

/** Topics: nested rules — a taxonomy with a parent and its children. */
export const TopicsIcon = () => (
  <svg {...base}>
    <path d="M3 5h14M6 10h11M6 15h11" />
    <path d="M3 10v5" opacity="0.5" />
  </svg>
);

/** People: a gauge of three, because the directory ranks by measured activity. */
export const PeopleIcon = () => (
  <svg {...base}>
    <circle cx="7.5" cy="7" r="3" />
    <path d="M2.5 17c0-2.8 2.2-4.5 5-4.5s5 1.7 5 4.5" />
    <path d="M14.5 6v8" opacity="0.55" />
    <path d="M17.5 8.5v5.5" opacity="0.55" />
  </svg>
);

/** Me: one tick standing taller than the rest — your own trace. */
export const MeIcon = () => (
  <svg {...base}>
    <path d="M4 14v3M8 10v7M12 3v14M16 12v5" />
  </svg>
);
